import React from 'react';
import {Link} from 'react-router-dom';

const STAGE_COLORS = {
  DISCOVERY: 'bg-purple-100 text-purple-800',
  QUALIFIED: 'bg-blue-100 text-blue-800',
  PROPOSAL: 'bg-yellow-100 text-yellow-800',
  NEGOTIATION: 'bg-orange-100 text-orange-800',
  CLOSED_WON: 'bg-green-100 text-green-800',
  CLOSED_LOST: 'bg-red-100 text-red-800',
};

export default function RecentDeals({ deals = [] }) {
  const recent = [...deals]
    .sort((a, b) => (b.createdAt || '').localeCompare(a.createdAt || ''))
    .slice(0, 5);

  return (
    <div className="bg-white rounded-lg shadow">
      <div className="p-6 border-b">
        <h2 className="text-lg font-semibold text-gray-900">Recent Deals</h2>
      </div>
      <div className="p-6">
        {recent.length === 0 ? (
          <p className="text-gray-500 text-center py-6">No deals yet.</p>
        ) : (
          <table className="w-full">
            <thead>
              <tr className="text-left text-sm text-gray-500">
                <th className="pb-3">Deal</th>
                <th className="pb-3 hidden md:table-cell">Company</th>
                <th className="pb-3">Value</th>
                <th className="pb-3">Stage</th>
              </tr>
            </thead>
            <tbody>
              {recent.map((deal) => (
                <tr key={deal.id} className="border-t">
                  <td className="py-3">
                    <Link to={`/crm/deals/${deal.id}`} className="text-blue-600 hover:text-blue-800">{deal.name}</Link>
                  </td>
                  <td className="py-3 hidden md:table-cell">{deal.companyName || '—'}</td>
                  <td className="py-3 font-semibold">{deal.value != null ? `$${deal.value.toLocaleString()}` : '—'}</td>
                  <td className="py-3">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${STAGE_COLORS[deal.stage] || 'bg-gray-100 text-gray-800'}`}>
                      {deal.stage.replace(/_/g, ' ')}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
